import { type ReactNode, useState } from "react";
import { Level, type Size } from "@/shared/components/generic/UiEnums.ts";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";
import IconArrowLeftUturnSquare from "@/shared/components/generic/icons/IconArrowLeftUturnSquare.tsx";
import ScheduleCancellationDialog from "@/pages/human-resources/time-management/components/schedule-cancellation/ScheduleCancellationDialog.tsx";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";
import { useTranslation } from "react-i18next";

interface Properties {
  disabled: boolean;
  buttonSize: Size;
}

export default function ScheduleCancellationOpener(
  props: Properties,
): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <BasicTooltipWithOffset
        title={t("scheduleCancellation.goToPreviousVersion")}
      >
        <IconButton
          icon={IconArrowLeftUturnSquare}
          level={Level.TERTIARY}
          size={props.buttonSize}
          onClick={() => {
            setPopupOpen(true);
          }}
          disabled={props.disabled}
        />
      </BasicTooltipWithOffset>
      {popupOpen && (
        <ScheduleCancellationDialog
          onClose={() => {
            setPopupOpen(false);
          }}
        />
      )}
    </>
  );
}
